export var HIGHTOUCH_API_HOST = 'us-east-1.hightouch-events.com';
//# sourceMappingURL=index.js.map